import request from 'services/request';
import {
  FundamentalEpsUrl,
  FundamentalUrl,
  FundamentalWatchUrl,
} from 'routes/fundamental.routes';
import {
  getCommodities,
  normalizeAnalysisData,
  summaryNormalizer,
  updateEps,
} from 'utils/fundamental.util';
import { FundamentalDataType } from 'typings/fundamental.type';

export const getDefaultFundamentalDataAction = async (
  set,
  securityId,
): Promise<void> => {
  const response = await request.get(FundamentalUrl(securityId));
  if (response.ok) {
    const { data } = response.data;
    const fundamentalData: FundamentalDataType = {
      summary: summaryNormalizer(data),
      tableData: getCommodities(data.important_commodities, data.id),
    };
    set({
      fundamentalDefaultData: fundamentalData,
    });
  }
};

export const getFundamentalDataAction = async (
  set,
  securityId,
  fundamentalId,
): Promise<void> => {
  set({ fundamentalDataLoading: true, fundamentalDataError: false });
  const response = await request.get(FundamentalUrl(securityId, fundamentalId));
  if (response.ok) {
    const { data } = response.data;
    const fundamentalData: FundamentalDataType = {
      summary: summaryNormalizer(data),
      tableData: getCommodities(data.important_commodities, data.id),
    };
    if (data.is_default) {
      set({
        fundamentalDefaultData: fundamentalData,
      });
    } else {
      await getDefaultFundamentalDataAction(set, securityId);
    }

    set({
      fundamentalData,
      fundamentalDataLoading: false,
      fundamentalDataError: false,
    });
  } else set({ fundamentalDataLoading: false, fundamentalDataError: true });
};

export const getWatchDataAction = async (set): Promise<void> => {
  set({ watchError: false });
  const res = await request.get(FundamentalWatchUrl());
  if (res.ok) {
    set({ watchError: false, watchData: res.data.data });
  } else set({ watchError: true });
};

export const postChangedFormulaAction = async (
  set,
  data,
  unit,
  changedValues,
): Promise<void> => {
  set({ changeFormulaLoading: true, changeFormulaError: false });
  const analysis = normalizeAnalysisData(data, unit, changedValues);
  const response = await request.post(FundamentalEpsUrl(), {
    analysis,
    commit: false,
  });

  if (response.ok) {
    set((state) => ({
      changeFormulaLoading: false,
      fundamentalData: updateEps(
        state.fundamentalData,
        data,
        response.data.data[0],
      ),
    }));
  } else set({ changeFormulaError: true, changeFormulaLoading: false });
};
